import { observer } from "mobx-react-lite";
import { FC } from "react";
import styled from "@emotion/styled";
import { MDSText, MDSTextVariant, MDSTextWeight } from "@/mds";

interface AppCalloutBannerSlimPrimaryLabelProps {
  label: string;
}

export const AppCalloutBannerSlimPrimaryLabel: FC<AppCalloutBannerSlimPrimaryLabelProps> = observer(
  ({ label }) => {
    if (!label) return null;

    return (
      <PrimaryLabelText variant={MDSTextVariant.TextSm} weight={MDSTextWeight.SemiBold}>
        {label}
      </PrimaryLabelText>
    );
  }
);

const PrimaryLabelText = styled(MDSText)({
  marginBottom: "4px",
});
